module.exports = __webpack_public_path__ + "img/01.8a1b89bc.png";